import { render, staticRenderFns } from "./VerificationHistoryTable.vue?vue&type=template&id=5938bbcb"
import script from "./VerificationHistoryTable.vue?vue&type=script&lang=js"
export * from "./VerificationHistoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../Development/QC/qcheck-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports